import * as THREE from 'three';

export class SceneManager {
    constructor() {
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
        this.renderer = new THREE.WebGLRenderer({ 
            antialias: true,
            // Enable high precision shadows
            shadowMap: {
                enabled: true,
                type: THREE.PCFSoftShadowMap
            }
        });
        this.entities = [];
        this.player = null;
        
        // Settings menu
        // this.settingsMenu = new SettingsMenu();
    }

    init() {
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        
        // Enable physical lighting calculations for more realistic lighting
        this.renderer.physicallyCorrectLights = true;
        this.renderer.outputEncoding = THREE.sRGBEncoding;
        this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
        this.renderer.toneMappingExposure = 1.0;
        
        document.getElementById('game-container').appendChild(this.renderer.domElement);

        this.camera.position.z = 5;

        this.scene.background = new THREE.Color(0x87ceeb); // Sky blue background

        window.addEventListener('resize', () => this.onWindowResize());

        // Add basic lighting
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
        directionalLight.position.set(0, 10, 5);
        this.scene.add(ambientLight, directionalLight);
        
        // Initialize settings menu
        // this.settingsMenu.init();
        // this.settingsMenu.onSettingsChanged = (settings) => {
        //     this.applySettings(settings);
        // };
    }
    
    // Add an entity to the scene
    addEntity(entity) {
        this.entities.push(entity);
        this.scene.add(entity.getObject());
        
        // If this is a player entity, store a reference
        if (entity.constructor.name === 'Player') {
            this.player = entity;
        }
    }

    update(deltaTime) {
        // Update all entities
        for (const entity of this.entities) {
            if (entity.update) {
                entity.update(deltaTime);
            }
        }
    }

    render() {
        this.renderer.render(this.scene, this.camera);
    }

    onWindowResize() {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }
    
    // Toggle settings menu visibility
    // toggleSettingsMenu() {
    //     // this.settingsMenu.toggleVisibility();
    // }
    
    // Apply settings from menu to all relevant entities
    applySettings(settings) {
        // Apply to player if exists
        if (this.player && this.player.applySettings) {
            this.player.applySettings(settings);
        }
        
        // Apply to other entities or systems as needed
        // ...
    }
}
